import React from "react";
import "../../../css/Grupo3/G3Landing.css";
import Componente2 from "../../../Component/Grupo3/Componente2";

function Vista2() {
  return (
    <div className="wrapper">
      <Componente2 />
    </div>
  );
}

export default Vista2;
